import * as React from 'react';
import styled from '@emotion/styled';
import * as Colors from '../../../consts/variables';
import { __ } from '../../../helpers/TranslationService';
interface IRating {
    value: number;
    base?: number;
    string: string;
    amount: number;
}

const RatingWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const RatingValueWrapper = styled.div`
    width: 63px;
    height: 28px;
    background-color: ${({ theme }) => theme.background.main};
    color: ${({ theme }) => theme.colors.white[100]};
    font-weight: 400;
    font-size: 16px;
    line-height: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    border-radius: ${({ theme }) => theme.container.borderRadius};
`;

const RatingValue = styled.span`
    font-weight: 700;
`;

const RatingDescription = styled.span`
    padding-left: 4px;
    font-size: 0px;
    height: 22px;
`;

const RatingDescriptionText = styled.span`
    display: block;
    font-size: 14px;
    font-weight: 700;
    line-height: 14px;
`;

const RatingDescriptionSubText = styled.span`
    font-size: 10px;
    font-weight: 400;
    line-height: 14px;
`;

export const Rating = ({ value, base = 10, string, amount = 0 }: IRating) => {
    if (value && !value.toFixed) {
        return null;
    }
    return (
        <RatingWrapper>
            <RatingValueWrapper>
                <RatingValue>{value.toFixed(1)}</RatingValue>/{base}
            </RatingValueWrapper>
            <RatingDescription>
                <RatingDescriptionText>{string}</RatingDescriptionText>
                <RatingDescriptionSubText>
                    {amount + ' ' + __('reviews', 'dreamlines')}
                </RatingDescriptionSubText>
            </RatingDescription>
        </RatingWrapper>
    );
};
